// extracted by mini-css-extract-plugin
export default {"main":"Home_main__80Ael","left":"Home_left__AoSj8","right":"Home_right__8MCio"};